import { ElementRef } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit {

  public isLogin: boolean = false;
  public showHeader: boolean = true;
  feedbackmodalRef: BsModalRef;

  constructor(private modalService: BsModalService) { }

  ngOnInit() {

  }

  onComponentActivation(event) {
    if (event && event.displayHeader === false) {
      this.showHeader = false;
    } else if (event && event.title) {
      // Do not show header in Agent home component
      this.showHeader = !event.title.includes('Home');
    } else { this.showHeader = true; }

    // On page load show scroll top for mobile
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  onComponentDeActivation(event: any) {
    if (this.feedbackmodalRef) {
      this.feedbackmodalRef.hide();
    }
  }

  openFeedbackSurvey(surveyTemplate: any) {
    this.feedbackmodalRef = this.modalService.show(surveyTemplate, Object.assign({}, { class: 'custom-modal update-modal modal-lg' }));
  }

}
